import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DatePipe, KeyValue } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, NgModel } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject, debounceTime, filter, startWith } from 'rxjs';
import { CustommatdateService } from 'src/app/module/pierhippla/services/custommatdate.service';
import { DataService } from 'src/app/module/pierhippnv/services/data.service';
import { LoggerService } from 'src/app/module/pierhippnv/services/logger.service';
import { ValidationService } from 'src/app/module/pierhippnv/services/validation.service';
import { AddressService } from 'src/app/shared/address.service';
import { AlertComponent } from '../dialog/alert.component';
import { AddressDTO, FormDTO, MemberDTO, Prefrence, ResponseDTO, verifyMemberRequest, verifyMemberResponse } from '../interfaces';
import { CaptchaService } from 'src/app/shared/captcha.service';
import { config } from 'src/app/shared/config';

const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();
const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'MMDDYYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'MM/DD/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-nvform',
  templateUrl: './nvform.component.html',
  styleUrls: ['./nvform.component.css'],
  providers: [
    { provide: DateAdapter, useClass: CustommatdateService },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class NvformComponent implements OnInit, OnChanges {
  timerReset: number = 0;
  apiError: HttpErrorResponse | undefined;
  captchaText: string = '';
  public datePipe: DatePipe;
  othermedicaidavailable: boolean =false;
  addressSuggestions: any = {
    resAddress: [],
    mailAddress: [],
    referralPolicyAddress: [],
    referralEmployerAddress: []
  }

  ngAfterContentChecked(): void {
    this.changeDetector?.detectChanges();
  }

  verifyMember: verifyMemberRequest = {
    firstNm: '',
    lastNm: '',
    ssnNum: '',
    dobDt: '',
    pierId: null,
  };
  memberObj1: MemberDTO = {
    firstNm: '',
    miNm: '',
    lastNm: '',
    dobDt: '',
    ssnNum: '',
    maNum: '',
    gender: '',
    relationship: 'SELF',
    enrolledInPolicy: false,
    healthCondition: '',
    existingMember: false,
    memberPierId: null,
    medicaidRecipient:false,

  };


  resAddressFormControl = new FormGroup({
    addressTypeCd: new FormControl('R'),
    addressLine1Txt: new FormControl(''),
    addressLine2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value: '', disabled: true}),
    zipCd: new FormControl(''),

  });

  mailAddressFormControl = new FormGroup({
    addressTypeCd: new FormControl('M'),
    addressLine1Txt: new FormControl(''),
    addressLine2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value: '', disabled: true}),
    zipCd: new FormControl(''),

  });

  referralPolicyAddressFormControl = new FormGroup({
    addressLine1Txt: new FormControl(''),
    addressLine2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value: '', disabled: true}),
    zipCd: new FormControl('')
  });

  referralEmployerAddressFormControl = new FormGroup({
    addressLine1Txt: new FormControl(''),
    addressLine2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value: '', disabled: true}),
    zipCd: new FormControl('')
  });


  submittedResponse: ResponseDTO = {
    referralId: undefined,
    pdfBytes: '',
  };

  formNv: FormDTO = {
    referralCase: {
      emailTxt: '',
      phone1Num: '',
      phone2Num: '',
      submitterFirstName: '',
      submitterLastName: '',
      updateReason: '',
      pierId: '',
      hipaaRecipientFirstNm: '',
      hipaaRecipientLastNm: '',
      hipaaSubmitterFirstName: '',
      hipaaSubmitterLastName: '',
      hipaaMedicaidNum: '',
      hippEffectiveDate: '',
      existingCase: false,
      sourceCd: '',
    },
    referralEmployer: {
      emplyrFein: '',
      emplyrNm: '',
      addressLine1Txt: '',
      addressLine2Txt: '',
      cityTxt: '',
      stateCd: '',
      zipCd: '',
      phoneNum: '',
      openEnrollmentStartDate: '',
      openEnrollmentEndDate: '',
    },
    referralPolicy: {
      policySourceCd: '',
      carrierNm: '',
      addressLine1Txt: '',
      addressLine2Txt: '',
      cityTxt: '',
      stateCd: '',
      zipCd: '',
      phoneNum: '',
      planNm: '',
      groupNum: '',
      policyNum: '',
      policyStartDate: null,
      employeePremium: '',
      frequency: '',
      planTier: '',
      individualMaxDeductible: '',
      familyMaxDeductible: '',
    },
    referralAddressList: [],
    referralMemberList: [],
    referralCoverage: {
      majorMedical: false,
      hmo: false,
      dental: false,
      vision: false,
      medicare: false,
      prescriptionDrugs: false,
    },
  };
  additionalMaxReached: boolean = false;
  existingInvalidMemberName: string = '';
  previousValRes: any;
  previousValMail: any;
  previousValRefEmp: any;
  previousValRefPol: any;


  constructor(
    private dataService: DataService,
    private logger: LoggerService,
    private deviceDetectorService: DeviceDetectorService,
    private addressService: AddressService,
    private dialog: MatDialog,
    private changeDetector: ChangeDetectorRef,
    private sanitize: DomSanitizer,
    private captchaService: CaptchaService
  ) {
    this.timerStart(15);
    this.datePipe = new DatePipe('en-US');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.errorMessageIntialData != '') {
      this.errorMessage = this.getMessageServerDown();
      setTimeout(() => {
        this.changeResetMessage();
        this.errorMessage = '';
      }, 10000);
    }
  }

  // alertDialogData: IAlertDialogData = {
  //   title: 'Session Timer',
  //   content: `
  //   <br />
  //   <p>Your session is about to end, and your changes will not be saved. </p>
  //   <p> Would you like to extend your session?</p>
  //   <br />
  //       `,
  //   confirmButtonText: ''
  // };

  @Input() preference: Prefrence | null = null;
  @Input() email: string | undefined = '';
  @Input() tollfreeNo: string | undefined | null = '';
  @Input() faxNo: string | undefined | null = '';
  @Input() address: string = '';
  @Input() emailTo: string = '';

  @ViewChild('customerForm')
  customerForm: NgForm = {} as NgForm;

  @ViewChild('captcha')
  captcha: NgModel = {} as NgModel;

  @ViewChild('MemberSsn')
  MemberSsn: NgModel = {} as NgModel;

  @ViewChild('otherSsn')
  otherSsn: NgModel = {} as NgModel;

  @ViewChild('otherDob')
  otherDob: NgModel = {} as NgModel;

  existingMemberFn() {
    this.updateReason = '';
    this.updateReasonRequired = false;
    this.refferalSourceRequired = false;
    this.firstNameRequired = false;
    this.lastNameRequired = false;
    this.ssnMemberRequired = false;
    this.memberGenderRequired = false;
    this.memberDobRequired = false;
    this.memberMedicateRequired = false;
    this.resAddress1Required = false;
    this.resCityRequired = false;
    this.resStateRequired = false;
    this.resZipRequired = false;
    this.isSameRequired = false;
    this.mailAddress1Required = false;
    this.mailCityRequired = false;
    this.mailStateRequired = false;
    this.mailZipRequired = false;
    this.addMember = true;
  }

  goForward() {
    if (this.policyHolderCheck() && !this.employerPolicyCheck()) {
      if (this.existingMember == 'No') {
        this.eplyrNmRequired = true;
        this.emplyrAddr1Required = true;
        this.emplyrCityRequired = true;
        this.emplyrStateRequired = true;
        this.emplyrZipCodeRequired = true;
        this.emplyrPhoneRequired = true;
        this.emplyrFeinRequired = true;
        this.emplyrEnrollmentStartRequired = true;
        this.emplyrEnrollmentEndRequired = true;
      }
      this.sourceCdRequired = true;
      if (this.existingMember == 'Yes') {
        this.premiumAmountRequired = true;
        this.singleDeductibleRequired = true;
        this.frequencyRequired = true;
        this.planTierRequired = true;
        this.premieumPaidOptionRequired = true;
        this.familyDeductibleRequired = true;
      }
    }
    this.timerReset =Math.random()* 100;
  }
  goBack() {
    this.maNumRequired = false;
    this.sourceCdRequired = false;
    this.premiumAmountRequired = false;
    this.singleDeductibleRequired = false;
    this.familyDeductibleRequired = false;
    this.frequencyRequired = false;
    this.planTierRequired = false;
    this.eplyrNmRequired = false;
    this.emplyrAddr1Required = false;
    this.emplyrAddr2Required = false;
    this.emplyrCityRequired = false;
    this.emplyrStateRequired = false;
    this.emplyrZipCodeRequired = false;
    this.emplyrPhoneRequired = false;
    this.emplyrFeinRequired = false;
    this.policyStateRequired = false;
    this.premieumPaidOptionRequired = false;
    this.emplyrEnrollmentStartRequired = false;
    this.emplyrEnrollmentEndRequired = false;
  }
  goForward2() {
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      !this.familyMemberCheck()
    ) {
      this.isFamilyRequired = true;
    }
    if (!this.checkAdditionalMembers()) {
      this.additionalMembersReq = true;
    } else {
      this.additionalMembersReq = false;
    }
    if (
      this.isFamilyMemberMedicate == 'Yes' &&
      this.formNv.referralMemberList.length > 50
    ) {
      this.additionalMaxReached = true;
    } else {
      this.additionalMaxReached = false;
    }
    if (
      this.otherfirstNm != '' &&
      this.otherlastNm != '' &&
      (this.otherdobDate != null && this.otherDob!=null && this.otherDob.control.value !='') &&
      this.otherEnrolled != ''
    ) {
      this.addClearFamilyFilled = true;
    } else {
      this.addClearFamilyFilled = false;
    }
    if(this.isMemberMedicaid == 'No' && this.formNv.referralMemberList.length > 0){
     if(this.othermedicaidavailable == false){
        this.openMedicaidDialog();
      }
    }
    this.timerReset =Math.random()* 100;
  }
  goBack2() {
    this.isFamilyRequired = false;
    this.additionalMembersReq = false;
    this.additionalMaxReached = false;
    this.otherFnRequired = false;
    this.otherLnRequired = false;
    this.otherEnrolledRequired = false;
    this.otherMaNumRequired = false;
    this.isOtherMedicateRequired = false;
    this.otherDobRequired = false;
    this.otherGnRequired = false;
    this.otherRsRequired = false;
    this.addClearFamilyFilled = false;
  }
  goForward3() {
    this.hippeffectivedate1 = this.datePipe.transform(this.today, 'MM-dd-yyyy');
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      !this.rightsResponsibilityCheck()
    ) {
      this.signCheckRequired = true;
    }
    this.timerReset =Math.random()* 100;
  }
  goBack3() {
    this.signCheckRequired = false;
  }
  goForward4() {
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.rightsResponsibilityCheck()
    ) {
      this.recipientfirstNmRequired = true;
      this.recipientLastNmRequired = true;
      this.isMedicaidReq = true;
      this.hippEffectiveDateReq = true;
      this.hippEffectiveDateReq1 = true;
      this.submitterFirstNmRequired = true;
      this.submitterLastNmRequired = true;
    }
    this.timerReset =Math.random()* 100;
  }

  goBack4() {
    this.recipientfirstNmRequired = false;
    this.recipientLastNmRequired = false;
    this.isMedicaidReq = false;
    this.hippEffectiveDateReq = false;
    this.hippEffectiveDateReq1 = false;
    this.submitterFirstNmRequired = false;
    this.submitterLastNmRequired = false;
  }
  goForward5() {
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.rightsResponsibilityCheck() &&
      this.voterRegistrationCheck()
    ) {
      this.signElectronicRequired = true;
      this.signApplicantRequired = true;
      this.signfirstNmRequired = true;
      this.signLastNameRequired = true;
      this.captchaRequired = true;
    }
    if (this.submitCheck()) {
      this.submit();
    }
    this.timerReset =Math.random()* 100;
  }
  goBack5() {
    this.signElectronicRequired = false;
    this.signApplicantRequired = false;
    this.signfirstNmRequired = false;
    this.signLastNameRequired = false;
    this.captchaRequired = false;
  }

  checkPage2Valid() {
    if(!this.referralEmployerAddressFormControl.valid) {
      return false;
    }
    if(!this.referralPolicyAddressFormControl.valid) {
      return false;
    }
    return true;
  }

  farword() {
    if (this.existingMember != '') {
      if (this.existingMember == 'Yes' && this.updateReason == '') {
        this.updateReasonRequired = true;
      }
      if (this.existingMember == 'No') {
        this.refferalSourceRequired = true;
      }
      this.firstNameRequired = true;
      this.lastNameRequired = true;
      if (this.MemberSsn.value == '') {
        this.ssnMemberRequired = true;
      }

      if (this.isMemberMedicaid == 'Yes') {
        this.maNumRequired = true;
      }

      this.validateAdress(<AddressDTO>this.resAddressFormControl.getRawValue(), this.resAddressFormControl);
      if(this.isSameMailingAddress == 'No'){
        this.validateAdress(<AddressDTO>this.mailAddressFormControl.getRawValue(), this.mailAddressFormControl);
      }

      this.memberDobRequired = true;
      this.memberMedicateRequired = true;
      this.memberGenderRequired = true;
      this.resAddress1Required = true;
      this.resStateRequired = true;
      this.isSameRequired = true;
      this.mailAddress1Required = true;
      this.mailCityRequired = true;
      this.mailStateRequired = true;
      this.mailZipRequired = true;
    } else {
      this.updateReasonRequired = false;
      this.refferalSourceRequired = false;
      this.firstNameRequired = false;
      this.lastNameRequired = false;
      this.ssnMemberRequired = false;
      this.memberDobRequired = false;
      this.memberMedicateRequired = false;
      this.resAddress1Required = false;
      this.resCityRequired = false;
      this.resStateRequired = false;
      this.resZipRequired = false;
      this.isSameRequired = false;
      this.mailAddress1Required = false;
      this.mailCityRequired = false;
      this.mailStateRequired = false;
      this.mailZipRequired = false;
    }
    this.timerReset =Math.random()* 100;
  }
  signApplicantCheck() {
    if (this.signApplicant == 'self' || this.signApplicant == 'onbehalf') {
      this.formNv.referralCase.submitterFirstName = '';
      this.formNv.referralCase.submitterLastName = '';
    }
  }
  //w9_pdf: any;
  //EFT_pdf: any;
  voteLink: any;
 // voter_pdf: any;
  downloadLink: any;
  disableSearch = false;

  ngOnInit(): void {
    this.captchaText = this.captchaService.generateCaptcha();
    this.voteLink = this.sanitize.bypassSecurityTrustUrl(
      'http://www.geauxvote.com/'
    );
    this.downloadLink =
      this.sanitize.bypassSecurityTrustUrl('javascript:void(0)');
    this._success.subscribe((message) => (this.successMessage = message));
    this._success.pipe(debounceTime(5000)).subscribe(() => {
      this.successMessage = '';
      //window.location.reload();
    });
    this._danger.subscribe((message) => (this.errorMessage = message));
    this._danger.pipe(debounceTime(3000)).subscribe(() => {
      this.errorMessage = '';
      //window.location.reload();
    });
    this._warning.subscribe((message) => (this.warningMessage = message));
    this._warning.pipe(debounceTime(2000)).subscribe(() => {
      this.warningMessage = '';
      if (!(window as any).__KARMA_TEST_MODE__) {
        window.location.reload();
      }
    });

    let resAddressLine1 = this.resAddressFormControl.controls.addressLine1Txt;
    this.resAddressFormControl.controls.addressLine1Txt.valueChanges.pipe(
      startWith(''),
      filter(() => !this.disableSearch),
      debounceTime(1000),
    ).subscribe(val => {
      if(this.disableSearch || !val) return;
      if(this.resAddressFormControl.controls.zipCd.value) return;
      if(val?.length<6){
        this.previousValRes="";
      }
      if (this.previousValRes?.trim() == resAddressLine1?.value?.trim()) return;      
      if(
        this.resAddressFormControl.controls.addressLine1Txt.value =='PO BOX') {
       this.addressSuggestions.resAddress = [];
       return
     }
     if(val?.length>5){
      this.setPreviousVal(val, 'resAddress');     
      this.fetchAddressList(this.resAddressFormControl, this.resAddressFormControl.controls.addressLine1Txt,'NV', true, 'resAddress');
     }
  })

  let mailAddressLine1 = this.mailAddressFormControl.controls.addressLine1Txt;
    this.mailAddressFormControl.controls.addressLine1Txt.valueChanges.pipe(
      startWith(''),
      filter(() => !this.disableSearch),
      debounceTime(1000),
    ).subscribe(val => {
      if(this.disableSearch || !val ) return;
      if(val?.length<6){
        this.previousValMail="";
      }
      if (this.previousValMail?.trim() == mailAddressLine1?.value?.trim()) return;
      if(this.mailAddressFormControl.controls.zipCd.value) return;
      if(val?.length>5){
        this.setPreviousVal(val, 'mailAddress');      
        this.fetchAddressList(this.mailAddressFormControl, this.mailAddressFormControl.controls.addressLine1Txt, '', false, 'mailAddress');
      }
  })

  let refEmpAddressLine1 = this.referralEmployerAddressFormControl.controls.addressLine1Txt;
  this.referralEmployerAddressFormControl.controls.addressLine1Txt.valueChanges.pipe(
    startWith(''),
    filter(() => !this.disableSearch),
    debounceTime(1000),
  ).subscribe(val => {
    if(this.disableSearch || !val ) return;
    if(val?.length<6){
      this.previousValRefEmp="";
    }
    if (this.previousValRefEmp?.trim() == refEmpAddressLine1?.value?.trim()) return;
    if(this.referralEmployerAddressFormControl.controls.zipCd.value) return;
    if(val?.length>5){
      this.setPreviousVal(val, 'referralEmployerAddress');
      this.fetchAddressList(this.referralEmployerAddressFormControl, this.referralEmployerAddressFormControl.controls.addressLine1Txt, '', false, 'referralEmployerAddress');
    }
  })

  let refPolAddressLine1 = this.referralPolicyAddressFormControl.controls.addressLine1Txt;
  this.referralPolicyAddressFormControl.controls.addressLine1Txt.valueChanges.pipe(
    startWith(''),
    filter(() => !this.disableSearch),
    debounceTime(1000),
  ).subscribe(val => {
    if(this.disableSearch || !val ) return;
    if(val?.length<6){
      this.previousValRefPol="";
    }
    if (this.previousValRefPol?.trim() == refPolAddressLine1?.value?.trim()) return;
    if(this.referralPolicyAddressFormControl.controls.zipCd.value) return;
    if(val?.length>5){
      this.setPreviousVal(val, 'referralPolicyAddress');
      this.fetchAddressList(this.referralPolicyAddressFormControl, this.referralPolicyAddressFormControl.controls.addressLine1Txt, '', false, 'referralPolicyAddress');
    }
  })
  }

  generateCaptcha(): void {
    this.captchaText = this.captchaService.generateCaptcha();
  }
  playCaptchaAudio(): void {
    this.captchaService.playCaptchaAudio();
  }
  fetchAddressList(formGroup: FormGroup, control: FormControl, requiredState: string, stateRestrciton: boolean, propName: string) {
    if(control.value.length > 5){
      const resAddress = formGroup.getRawValue();
      let address1Line = this.capitalize(control.value.toLowerCase());
      let existingAddress = this.addressSuggestions[propName].filter((item: any)  => 
        item.street_line?.includes(address1Line));
      if(this.addressSuggestions[propName].length >0 && existingAddress.length>0){
        this.addressSuggestions[propName] = existingAddress;
       
      }else{
        this.addressService.autocompleteAddress(resAddress, requiredState, stateRestrciton).then(
          (data:any)=> {
            if(propName=='resAddress'){
              const filteredResults = data.suggestions.filter((result: { street_line: string; }) =>!this.isPOBox(result?.street_line));
              this.addressSuggestions[propName] = filteredResults;
            } else {
              this.addressSuggestions[propName] = data.suggestions;
            }
            // this.initRequest[propName] = false;
            if(this.addressSuggestions[propName].length ==0) {
              if( resAddress.cityTxt=='' || resAddress.stateCd=='' ||resAddress.zipCd==''){
                control.setErrors({...(control.errors || {}),'invalid': true});
              }else{
                if(control.errors)
                    delete  control.errors['invalid'];
              }
            }
          }
        );
      }
      
    }else{
      this.addressSuggestions[propName] =[];
    }
    
  }
  capitalize(value: string): string {
    if (!value) return value;
    return value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  model2: string | undefined;
  private _success = new Subject<string>();
  private _warning = new Subject<string>();
  private _danger = new Subject<string>();
  staticAlertClosed = false;
  ssnValidationError: string = '';
  signFirstName: string = '';
  signLastName: string = '';
  signApplicant: string = '';
  signReadCheck: boolean = false;
  signElectronicSignatureChecked: boolean = false;
  isSameMailingAddress: string = '';
  isHealthInsurance: string = '';
  isMemberMedicaid: string = '';
  existingMember: string | null = null;
  existingOtherMember: string | null = null;
  existingMemberVerified: boolean = false;
  updateReason: string = '';
  sourceCdRequired: boolean = false;
  premiumAmountRequired: boolean = false;
  singleDeductibleRequired: boolean = false;
  frequencyRequired: boolean = false;
  planTierRequired: boolean = false;
  premieumPaidOptionRequired: boolean = false;
  familyDeductibleRequired: boolean = false;
  isFamilyRequired: boolean = false;
  recipientfirstNmRequired: boolean = false;
  recipientLastNmRequired: boolean = false;
  isMedicaidReq: boolean = false;
  hippEffectiveDateReq: boolean = false;
  hippEffectiveDateReq1: boolean = false;
  submitterFirstNmRequired: boolean = false;
  submitterLastNmRequired: boolean = false;
  signCheckRequired: boolean = false;
  signElectronicRequired: boolean = false;
  signApplicantRequired: boolean = false;
  signfirstNmRequired: boolean = false;
  signLastNameRequired: boolean = false;
  captchaRequired: boolean = false;
  editIndex?: number = undefined;
  otherFnRequired: boolean = false;
  otherLnRequired: boolean = false;
  otherSsnRequired: boolean = false;
  otherDobRequired: boolean = false;
  otherGnRequired: boolean = false;
  otherRsRequired: boolean = false;
  otherEnrolledRequired: boolean = false;
  otherMaNumRequired: boolean = false;
  isOtherMedicateRequired:boolean = false;
  addClearFamilyFilled: boolean = false;
  additionalMembersReq: boolean = false;
  resAddress1Required: boolean = false;
  eplyrNmRequired: boolean = false;
  emplyrAddr1Required: boolean = false;
  emplyrAddr2Required: boolean = false;
  emplyrCityRequired: boolean = false;
  emplyrStateRequired: boolean = false;
  emplyrZipCodeRequired: boolean = false;
  emplyrPhoneRequired: boolean = false;
  emplyrFeinRequired: boolean = false;
  resCityRequired: boolean = false;
  resStateRequired: boolean = false;
  resZipRequired: boolean = false;
  isSameRequired: boolean = false;
  mailAddress1Required: boolean = false;
  mailCityRequired: boolean = false;
  mailStateRequired: boolean = false;
  mailZipRequired: boolean = false;
  updateReasonRequired: boolean = false;
  refferalSourceRequired: boolean = false;
  policyStateRequired: boolean = false;
  firstNameRequired: boolean = false;
  lastNameRequired: boolean = false;
  ssnMemberRequired: boolean = false;
  memberDobRequired: boolean = false;
  memberMedicateRequired: boolean = false;
  memberGenderRequired: boolean = false;
  emplyrEnrollmentStartRequired: boolean = false;
  emplyrEnrollmentEndRequired: boolean = false;
  maNumRequired: boolean = false;
  stateRestrciton: boolean = false;
  requiredState: string = '';
  memberPierId: string | null = null;
  otherMemberPierId: string | null = null;



  showResAddress: boolean = false;
  showMailAddress: boolean = false;
  showEmployerAddress: boolean = false;
  showPolicyAddress: boolean = false;

  successMessage: string = '';
  warningMessage: string = '';
  otherEnrolled: string = '';
  cobra: string = '';
  isFamilyMemberMedicate: string = '';
  captchaEntered: string = '';
  isValidFormSubmitted: boolean = false;
  errorMessage: string = '';
  operationText = 'Submit';
  // @Input() contextCd: string = '';
  // @Input() subContextCd: string = '';
  @Input() errorMessageIntialData: string = '';
  isSsnPresentDB: boolean = false;
  memberVOdobDt!: Date;
  policyVOpolicyStartDate!: Date;
  hippeffectivedate!: Date | null;
  hippeffectivedate1!: string | null;
  openenrollmentstartdate!: Date | null;
  openenrollmentenddate!: Date | null;
  cobraStartDate!: Date;
  cobraEndDate!: Date;
  otherdobDate!: Date | null;
  addFamilyMemberButton: boolean = false;
  addMember: boolean = false;

  today: Date = today;
  plus1year: Date = new Date(year + 1, month, today.getDate());
  prev10year: Date = new Date(year - 10, month, today.getDate());
  next5year: Date = new Date(year + 5, month, today.getDate());
  prev100year: Date = new Date(year - 100, month, today.getDate());

  originalOrder = (
    a: KeyValue<string, string>,
    b: KeyValue<string, string>
  ): number => {
    return 0;
  };

  otherfirstNm: string = '';
  otherlastNm: string = '';
  othermiNm?: string = '';
  otherssnNum: string = '';
  othermaNum?: string = '';
  othergenderRf?: string = '';
  otherrelationshipRf?: string = '';
  otherdobDt: string = '';
  isOtherMedicaid:string = '';
  display: any;
  alreadySubmitted: boolean = false;
  healthCondition: string = '';
  othermempierid: string |null= null ;

  checkCaptch(event: any) {
    if (
      this.captchaEntered != '' &&
      this.captchaEntered != this.captchaText
    ) {
      this.captcha.control.setErrors({ nomatch: true });
      return false;
    } else {
      this.captcha.control.setErrors(null);
      return true;
    }
  }

  submit() {
    if (this.captchaEntered == '') {
      return;
    } else if (this.captchaEntered != this.captchaText) {
      return;
    }


    if(this.memberPierId == null && this.formNv.referralMemberList.length > 0){

      this.formNv.referralMemberList.forEach(mem => {
        if (mem.memberPierId != null){
          this.otherMemberPierId=  mem.memberPierId;
          this.existingOtherMember = 'Yes';
          mem.memberPierId = null;
        }

      });
    }else if(this.memberPierId == null && this.formNv.referralMemberList.length == 0 ){
      this.otherMemberPierId=  null;
    }

    if (this.existingMember == 'Yes' || (this.formNv.referralMemberList.length > 0 && this.existingOtherMember == 'Yes')) {
      this.formNv.referralCase.existingCase = true;
      this.formNv.referralCase.pierId = this.memberPierId!=null? this.memberPierId: this.otherMemberPierId;
    }


    // this.formNv.referralCase.existingCase = this.existingMember == 'Yes';
    // if (this.existingOtherMember == 'Yes') {
    //   this.formNv.referralCase.existingCase = true;
    // }

    // this.formNv.referralCase.pierId = this.memberPierId;

    //this.formNv.clientCd = this.preference?.contextDtl?.clientCode;
    if (this.existingMember == 'Yes') {
      this.formNv.referralCase.updateReason = this.updateReason;
    }

    if(this.isSameMailingAddress =='Yes'){
      this.mailAddressFormControl.patchValue(this.resAddressFormControl.getRawValue())
    }
    this.formNv.referralAddressList.push(<AddressDTO>this.resAddressFormControl.getRawValue());
    if(this.isSameMailingAddress=='No'){
      this.formNv.referralAddressList.push(<AddressDTO>this.mailAddressFormControl.getRawValue());
    }
    //this.formNv.referralCase.submittingByPH = this.signApplicant=='self'
    this.memberObj1.enrolledInPolicy = true;
    this.memberObj1.medicaidRecipient = this.isMemberMedicaid == 'Yes';
    this.memberObj1.dobDt = this.getServerDate(this.memberVOdobDt);

    this.formNv.referralPolicy.policyStartDate = this.getServerDate(
      this.policyVOpolicyStartDate
    );

    this.formNv.referralCase.hippEffectiveDate = this.getServerDate(
      this.hippeffectivedate
    );

    this.formNv.referralEmployer.openEnrollmentStartDate = this.getServerDate(
      this.openenrollmentstartdate
    );

    this.formNv.referralEmployer.openEnrollmentEndDate = this.getServerDate(
      this.openenrollmentenddate
    );

    if (
      this.isFamilyMemberMedicate == 'No' &&
      this.formNv.referralMemberList.length > 0
    ) {
      this.formNv.referralMemberList = [];
    }
    this.formNv.referralMemberList.push(this.memberObj1);
    this.formNv.referralMemberList?.forEach((object) => {
      if (object.ssnNum != '') {
        object.ssnNum = object.ssnNum.replaceAll('-', '');
        object.memberPierId = null;
      }
    });

    let individualMaxDeduct =
      this.formNv.referralPolicy.individualMaxDeductible;
    if (individualMaxDeduct == '') individualMaxDeduct = '0';
    this.formNv.referralPolicy.individualMaxDeductible = parseFloat(
      individualMaxDeduct!
    ).toFixed(2);

    let familyMaxDeduct = this.formNv.referralPolicy.familyMaxDeductible;
    if (familyMaxDeduct == '') familyMaxDeduct = '0';
    this.formNv.referralPolicy.familyMaxDeductible = parseFloat(
      familyMaxDeduct!
    ).toFixed(2);

    let premiumAmt = this.formNv.referralPolicy.employeePremium;
    if (premiumAmt == '') premiumAmt = '0';
    this.formNv.referralPolicy.employeePremium = parseFloat(
      premiumAmt!
    ).toFixed(2);

    let mempierid=this.formNv.referralCase.pierId;
    if (mempierid == '' || mempierid == null) {
      this.formNv.referralCase.pierId = '0';
    } else {
      this.formNv.referralCase.pierId =mempierid;
    }

    this.formNv.referralCase.phone1Num =
      this.formNv.referralCase.phone1Num?.replaceAll('-', '');
    this.formNv.referralCase.phone2Num =
      this.formNv.referralCase.phone2Num?.replaceAll('-', '');
    this.formNv.referralPolicy.phoneNum =
      this.formNv.referralPolicy.phoneNum?.replaceAll('-', '');
    this.formNv.referralEmployer.phoneNum =
      this.formNv.referralEmployer.phoneNum?.replaceAll('-', '');

    this.formNv.referralEmployer.emplyrFein =
      this.formNv.referralEmployer.emplyrFein?.replaceAll('-', '');
    this.formNv.referralEmployer.zipCd =
      this.formNv.referralEmployer.zipCd?.replaceAll('-', '');
    this.formNv.referralAddressList?.forEach((object) => {
      if (object.zipCd != '') {
        object.zipCd = object.zipCd?.replaceAll('-', '');
      }
    });
    this.formNv.referralPolicy.zipCd =
      this.formNv.referralPolicy.zipCd?.replaceAll('-', '');
    if (!this.alreadySubmitted) {
      this.alreadySubmitted = true;

      this.dataService.insertCustomerForm(this.formNv).subscribe({
        next: (response: ResponseDTO) => {
          if (response) {
            // Mark form as pristine so that CanDeactivateGuard won't prompt before navigation
            //this.referral.memberVOLst.pop();
            this.isValidFormSubmitted = true;
            this.submittedResponse = response;
            //console.log('ResponseId: '+insertedCustomer.reponseID)
            //this.router.navigate(['/customers']);
            clearInterval(this.timer);
            let addMins: number = 0;
            addMins = 15 - this.seconds / 60;
            this.timerStart(addMins);
          } else {
            this.formNv.referralMemberList.pop();
            const msg = 'Unable to save customer details';
            this.errorMessage = msg;
          }
          window.scrollTo(0, 0);
        },
        error: (err: HttpErrorResponse) => {
          this.warningMessage = '';
          this.logger.log(err.message);
          this.apiError = err;
          const msg = 'We are unable to save application details currently, please contact customer support.';
          this.errorMessage = msg;
          window.scrollTo(0, 0);
          this.isValidFormSubmitted = true;
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        },
      });

      if (this.errorMessage != '') {
        window.scrollTo(0, 0);
        this.customerForm?.resetForm();
      }
    }
  }
  addFamilyMember(event: Event) {
    this.addClearFamilyFilled = false;
    let valid = true;
    const form = this.customerForm?.form;

    if (form != null) {
      let page1 = [
        'isFamilyMemberMedicate',
        'otherfirstNm',
        'othermiNm',
        'otherlastNm',
        'otherssnNum',
        'd6',
        'othergenderRf',
        'othermaNum',
        'otherrelationshipRf',
        'CatastrophicHealthCondition',
        'otherEnrolled',
        'isOtherMedicaid',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
          break;
        }
      }
    }
    if (this.formNv.referralMemberList.length > 50) {
      this.additionalMaxReached = true;
    }
    if (valid && !this.additionalMaxReached) {

      (event.target as HTMLButtonElement).disabled = true;
      if (
        (this.otherdobDate != null && this.otherDob!=null && this.otherDob.control.value !='') &&
        this.otherfirstNm != '' &&
        this.otherlastNm != '' &&
        this.othergenderRf != '' &&
        this.otherrelationshipRf !='' &&
        this.otherEnrolled != '' &&
        this.memberObj1.ssnNum != '' && this.isOtherMedicaid !='' &&
        ((this.isOtherMedicaid =='Yes' && this.othermaNum != '')|| this.isOtherMedicaid =='No')
      ) {
        if (this.memberObj1.ssnNum == this.otherssnNum) {
          this.ssnValidationError = 'Duplicate ssn in the form';
          this.otherSsn.control.setErrors({ duplicate: true });
          return;
        }
        this.addFamilyMemberButton = true;
        if (this.editIndex != undefined) {
          this.formNv.referralMemberList.splice(this.editIndex, 1);
          this.editIndex = undefined;
        }
        // this.verifyMember.dobDt = this.getServerDate(this.otherdobDate);
        // this.verifyMember.ssnNum = this.otherssnNum;
        // this.verifyMember.pierId = this.memberPierId;

        let otherMembPierId: string |null =null;
        if(this.memberPierId == null && this.formNv.referralMemberList.length > 0){

          this.formNv.referralMemberList.forEach(mem => {
            if (otherMembPierId == null && mem.memberPierId != null){
              otherMembPierId=  mem.memberPierId;
            }
          });
        }

        this.verifyMember.firstNm = this.otherfirstNm;
        this.verifyMember.lastNm = this.otherlastNm;
        this.verifyMember.dobDt = this.getServerDate(this.otherdobDate);
        this.verifyMember.ssnNum = this.otherssnNum;
        this.verifyMember.pierId = this.memberPierId != null? this.memberPierId: otherMembPierId;


        this.verifyMember.ssnNum = this.verifyMember.ssnNum.replaceAll('-', '');

        this.dataService.getVerifyExistingMember(this.verifyMember).subscribe({
          next: (response: verifyMemberResponse) => {
            if (response) {
              if (response.addMember == true && response.existingMember == true && response.pierId != null) {
                this.otherMemberPierId = response.pierId;
                this.existingOtherMember = 'Yes';
              }
              this.addMember = response.addMember;

            }

            if (!this.addMember) {
              this.existingInvalidMemberName =
                this.verifyMember.firstNm + ' ' + this.verifyMember.lastNm;
              this.addFamilyMemberButton = false;
              this.openValidateMemberDialog();
              return;
            } else {
              if(this.otherfirstNm !='' && this.otherlastNm != '' && this.otherssnNum !=''){
                this.formNv.referralMemberList.push({
                  dobDt: this.getServerDate(this.otherdobDate),
                  firstNm: this.otherfirstNm,
                  lastNm: this.otherlastNm,
                  miNm: this.othermiNm,
                  ssnNum: this.otherssnNum,
                  maNum: this.othermaNum,
                  gender: this.othergenderRf,
                  relationship: this.otherrelationshipRf,
                  enrolledInPolicy: this.otherEnrolled == 'Yes',
                  existingMember: this.existingOtherMember == 'Yes',
                  healthCondition: this.healthCondition,
                  memberPierId: this.otherMemberPierId,
                  medicaidRecipient: this.isOtherMedicaid == 'Yes',
                });
              }

              this.checkAdditionalMembers();
              this.additionalMembersReq = false;
              this.addClearFamilyFilled = false;
              this.clear(event);
              this.otherfirstNm = '';
              this.othermiNm = '';
              this.otherssnNum = '';
              this.othermaNum = '';
              this.othergenderRf = '';
              this.otherrelationshipRf = '';
              this.healthCondition = '';
              this.otherMemberPierId = null;
              this.existingOtherMember = '';
              this.isOtherMedicaid ='';

            }
          },
          error: (err: HttpErrorResponse) => {
            this.logger.logMsg(err.error);
            const msg =
             'We are unable to verify Member details currently, please contact customer support.' + err.message;
            this.errorMessageIntialData = msg;
            window.scrollTo(0, 0);
            setTimeout(() => {
              this.errorMessage = '';
            }, 3000);
          },
        });
      } else {
        if (this.otherfirstNm == '') {
          this.otherFnRequired = true;
        }
        if (this.otherlastNm == '') {
          this.otherLnRequired = true;
        }
        if (this.otherEnrolled == '') {
          this.otherEnrolledRequired = true;
        }
        if(this.isOtherMedicaid == ''){
          this.isOtherMedicateRequired =true;
        }
        if (this.isOtherMedicaid == 'Yes' && this.othermaNum == '') {
          this.otherMaNumRequired = true;
        }
        if (this.otherssnNum == '') {
          this.otherSsnRequired = true;
        }
        if (this.otherDob.control.value == null || this.otherDob.control.value =='') {
          this.otherDobRequired = true;
        }
        if (this.othergenderRf == '') {
          this.otherGnRequired = true;
        }
        if (this.otherrelationshipRf == '') {
          this.otherRsRequired = true;
        }
      }
      (event.target as HTMLButtonElement).disabled = false;
    }else {
      if (this.otherfirstNm == '') {
        this.otherFnRequired = true;
      }
      if (this.otherlastNm == '') {
        this.otherLnRequired = true;
      }
      if (this.otherEnrolled == '') {
        this.otherEnrolledRequired = true;
      }
      if(this.isOtherMedicaid == ''){
        this.isOtherMedicateRequired =true;
      }
      if (this.isOtherMedicaid == 'Yes' && this.othermaNum == '') {
        this.otherMaNumRequired = true;
      }
      if (this.otherssnNum == '') {
        this.otherSsnRequired = true;
      }
      if (this.otherDob.control.value == null || this.otherDob.control.value =='') {
        this.otherDobRequired = true;
      }
      if (this.othergenderRf == '') {
        this.otherGnRequired = true;
      }
      if (this.otherrelationshipRf == '') {
        this.otherRsRequired = true;
      }
    }
  }

  clear(event: Event) {
    this.goBack3();
    this.addClearFamilyFilled = false;
    this.otherFnRequired = false;
    this.otherLnRequired = false;
    this.otherEnrolledRequired = false;
    this.otherSsnRequired = false;
    this.otherDobRequired = false;
    this.otherGnRequired = false;
    this.otherRsRequired = false;
    this.otherMaNumRequired = false;
    this.isOtherMedicateRequired = false;
    this.otherdobDt = '';
    this.otherfirstNm = '';
    this.otherlastNm = '';
    this.othermiNm = '';
    this.otherssnNum = '';
    this.othermaNum = '';
    this.isOtherMedicaid= '';
    this.othergenderRf = '';
    this.otherrelationshipRf = '';
    this.healthCondition = '';
    this.otherdobDate = null;
    if(this.otherDob && this.otherDob.control){
      this.otherDob.control.setValue('');
      this.otherDob.control.setErrors(null);
    }
    this.otherEnrolled = '';
    this.addMember = true;
    this.addFamilyMemberButton = false;
  }
  cancel(event: Event) {
    event.preventDefault();
    this.changeResetMessage();
    window.scrollTo(0, 0);
  }

  removeMember(memberIndex: number): void {
    const [removedUser] = this.formNv.referralMemberList.splice(memberIndex, 1);
    if (this.formNv.referralMemberList.length == 0) {
      this.additionalMembersReq = true;
    }
    if (this.formNv.referralMemberList.length <= 50) {
      this.additionalMaxReached = false;
    }
    if(removedUser?.existingMember && removedUser.memberPierId) {
      this.otherMemberPierId = null;
      this.existingOtherMember = 'No';
    }
  }

  editMember(memberIndex: number): void {
    let obj = this.formNv.referralMemberList[memberIndex];
    this.editIndex = memberIndex;
    this.otherfirstNm = obj.firstNm;
    this.otherlastNm = obj.lastNm;
    this.otherssnNum = obj.ssnNum;
    this.othermiNm = obj.miNm;
    this.othermaNum = obj.maNum;
    this.healthCondition = obj.healthCondition;
    this.othergenderRf = obj.gender;
    this.otherrelationshipRf = obj.relationship;
    this.otherdobDate = moment(obj.dobDt, 'MM/DD/YYYY').toDate();
    this.otherEnrolled = obj.enrolledInPolicy? 'Yes' : 'No';
    this.isOtherMedicaid = obj.medicaidRecipient? 'Yes' : 'No';
  }
  getServerDate(dateStruct: Date | null) {
    if (dateStruct != null) {
      return this.datePipe.transform(dateStruct, 'MM/dd/yyyy');
    }
    return null;
  }
  public changeSuccessMessage() {
    this._success.next(`${new Date()} - Form submitted successfully.`);
  }
  public changeResetMessage() {
    this._warning.next(` Form reset done.`);
  }
  allowAlphabets(event: any) {
    return ValidationService.allowAlphabets(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowAlphabets2(event: any, control: NgModel) {
    return ValidationService.allowAlphabets2(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  allowAlphaNumericWithSplChars(event: any,control: NgModel){
    return ValidationService.allowAlphaNumericWithSplChars(
      event,
      this.deviceDetectorService.browser,
      control
    );


  }
  allowAlphaNumericWithTwoSplChar(event: any, control: NgModel){
    return ValidationService.allowAlphaNumericWithTwoSplChar(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  allowAlphaNumericForCarrier(event: any, control: NgModel){
      return ValidationService.allowAlphaNumericForCarrier(
        event,
        this.deviceDetectorService.browser,
        control
      );
  }
  allowAlphaNumericWithoutSpace(event: any, control: NgModel) {
    return ValidationService.allowAlphaNumericWithoutSpace(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  allowAlphaNumericWithSpace(event: any, control: NgModel) {
    return ValidationService.allowAlphaNumericWithSpace(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }

  isNumeric(elem: any, control: NgModel) {
    return ValidationService.isNumeric2(
      elem,
      this.deviceDetectorService.browser,
      control
    );
  }

  oneSpaceAllowed(event: any) {
    return ValidationService.oneSpaceAllowed(event);
  }

  allowAlphaNumeric(event: any) {
    return ValidationService.allowAlphaNumeric(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowAlphaNumericWithSplHash(event: any) {
    return ValidationService.allowAlphaNumericWithSplHash(
      event,
      this.deviceDetectorService.browser
    );
  }
  validatePremiumAmountFormat(event: any) {
    return ValidationService.validatePremiumAmountFormat(
      event,
      this.deviceDetectorService.browser
    );
  }
  ssnmask(ssn: any, control: NgModel) {
    return ValidationService.ssnmask(ssn, control);
  }

  // Method to check if an address contains a PO Box
isPOBox(address:string):boolean {
  const poBoxPatterns = [/P\.?O\.?\s?Box/i, /Post\s?Office\s?Box/i];
  // Add more patterns if needed
  return poBoxPatterns.some(pattern =>
  pattern.test(address));
}

  async setDefaultBlank(event: any, controlName: string, formGroup: FormGroup, propName: string){
    let cityTxt =formGroup.controls['cityTxt'];
    let stateCd =formGroup.controls['stateCd'];
    let zipCd =formGroup.controls['zipCd'];
    const key = event.keyCode || event.charCode;
    if(this.addressSuggestions[propName].length >0 && event.target.value.length < 6){
      this.addressSuggestions[propName] = [];
    }
   
  if((event.ctrlKey && event.key === 'v') || (event.ctrlKey && event.key === 'c') || key != 37 && key != 38 && key != 39 && key != 40 && event.keyCode!=13 && event.keyCode!= 9){     
    if(cityTxt.value !='' || stateCd.value !='' || zipCd.value !='' || key === 8 || key === 46  ||(event.ctrlKey && event.key === 'x')){
           
       if(controlName =='mailAddress.addressLine1Txt'){
         this.showMailAddress=false;
       }else if(controlName =='caseVO.addressLine1Txt'){
       this.showResAddress=false;
       } else if(controlName =='employerVO.addressLine1Txt') {
         this.showEmployerAddress = false;
       } else if(controlName =='policyVO.addressLine1Txt') {
         this.showPolicyAddress = false;
       }
       formGroup.patchValue({
        addressLine2Txt: '',
         cityTxt: '',
         stateCd: '',
         zipCd: '',
       });
     }

     if(controlName =='caseVO.addressLine1Txt' && this.resAddressFormControl.value?.addressLine1Txt?.includes('PO BOX')){
       this.resAddressFormControl.controls.addressLine1Txt.setErrors({'po': true});
     }
  }

 }


selectSuggestion(fromGroup: FormGroup,name:string, control: FormControl, suggestion: any, trigger: any, propName: string) {
  if(suggestion?.option?.value?.secondary && suggestion?.option?.value?.entries > 1 ){
    this.disableSearch = true;
    const selectedAddress = suggestion?.option?.value?.street_line +' '+ suggestion?.option?.value?.secondary + ' ('+suggestion?.option?.value?.entries + ') '+
    suggestion?.option?.value?.city +' '+ suggestion?.option?.value?.state +' '+ suggestion?.option?.value?.zipcode;
    control.setValue(suggestion?.option?.value?.street_line.toUpperCase());

    this.addressSuggestions[propName] = [];
    this.setPreviousVal(suggestion?.option?.value?.street_line, propName);
    this.addressService.autocompleteSelectedAddress(suggestion?.option?.value?.street_line.toUpperCase(), selectedAddress).then(
      (data:any)=> {
        this.addressSuggestions[propName] = data.suggestions;
        if(trigger) {
          trigger.openPanel();
        }
        setTimeout (() => {
          this.disableSearch = false;
        },9000)

      }
    )

    console.log("Address Suggestions: "+this.addressSuggestions);
  }  else{
  // selectSuggestion(control: NgModel, suggestion: any) {
    const address: AddressDTO = {
      addressTypeCd: '',
      addressLine1Txt: '',
      addressLine2Txt: '',
      cityTxt: '',
      stateCd: '',
      zipCd: ''
    };
    this.addressSuggestions[propName] = [];
    control.setValue(suggestion?.option?.value?.street_line.toUpperCase());
    if(name =='mailAddress.addressLine1Txt'){
      address.addressTypeCd = 'M';
      this.showMailAddress=true;
      this.addressService.setAddressDetails(address,suggestion);
      this.mailAddressFormControl.patchValue(address);
    } else if(name =='employerVO.addressLine1Txt'){
      this.showEmployerAddress=true;
      this.addressService.setAddressDetails(address,suggestion);
      this.referralEmployerAddressFormControl.patchValue(address);
      this.formNv.referralEmployer = {...this.formNv.referralEmployer, ...address };
    } else if(name =='policyVO.addressLine1Txt'){
      this.showPolicyAddress = true;
      this.addressService.setAddressDetails(address,suggestion);
      this.referralPolicyAddressFormControl.patchValue(address);
      this.formNv.referralPolicy = {...this.formNv.referralPolicy, ...address};
    } else if(name =='caseVO.addressLine1Txt'){
      address.addressTypeCd = 'R';
      this.showResAddress=true;
      this.addressService.setAddressDetails(address,suggestion);
      this.resAddressFormControl.patchValue(address);
    }
  }
}

onFocusInput() {
  //this.addressSuggestions = [];
}

validateAdress(address: AddressDTO, formGroup: FormGroup) {
  let valid = true;
  let addressControl = formGroup.controls['addressLine1Txt'];
  if(address.addressLine1Txt =="" ){
    if(addressControl.errors && addressControl.hasError('invalid') ){
      if(addressControl.hasError('required')){
        addressControl.setErrors({
          required: true, invalid: false
        });
      }
     
    }else{
      addressControl.setErrors({
        required: true
      });
    }
    valid = false;
  }else if(address.cityTxt =="" || address.stateCd =="" || address.cityTxt =="" ){
    if(!(addressControl.errors && addressControl.hasError('po')) && !(addressControl.errors && addressControl.hasError('invalid'))){
      addressControl.setErrors({invalid: true});
    }     
    valid = false;
  }else{
    if(addressControl.errors && addressControl.hasError('invalid') ){
      if(!addressControl.hasError('po')){
        if(!addressControl.hasError('required'))
          addressControl.setErrors(null);
      }else{
        addressControl.setErrors({
          invalid: false, po: true
        });
      }
    }
      
  }    
  return valid; 
}

  getKeyByValue(
    object: Record<string, string>,
    value: string
  ): string | undefined {
    return Object.keys(object).find((key) => object[key] === value);
  }


  phonemask2(phone: any, control: NgModel) {
    return ValidationService.phonemask2(phone, control);
  }

  datemask2(date: any, control: NgModel) {
    return ValidationService.datemask2(date, control);
  }
  onlyNumeric(elem: any, control: NgModel) {
    return ValidationService.onlyNumeric(
      elem,
      this.deviceDetectorService.browser,
      control
    ); 
  }
  isMedicaidValid(medicaid: any, control: NgModel) {
    let isValid = ValidationService.isMedicaidValid(medicaid.target.value);
    if (!isValid) {
      control.control.setErrors({ ...(control.errors || {}), invalid: true });
    } else {
      if (control.control.errors) delete control.control.errors['invalid'];
    }
  }

  isFEINValidValue(empFEIN: any, control: NgModel) {
    let isValid = ValidationService.isFEINValidValue(empFEIN.target.value);
    if (!isValid) {
      control.control.setErrors({ ...(control.errors || {}), invalid: true });
    } else {
      if (control.control.errors) delete control.control.errors['invalid'];
    }
  }
  empFEINMask(empFEIN: any, control: NgModel) {
    return ValidationService.empFEINMask(empFEIN, control);
  }
  amountMask(amount: any, control: NgModel) {
    return ValidationService.amountMask(amount, control);
  }
  validatePremiumAmount(amount: any, control: NgModel) {
    return ValidationService.validatePremiumAmount(amount, control);
  }

  getSSNUsedMessage() {
    return ValidationService.getSSNUsedMessage2(this.faxNo);
  }
  getMessageServerDown() {
    return ValidationService.getMessageServerDown();
  }

  verifySSN(event: any, isOtherSsn: boolean) {
    let ssn = event.target.value;
    let donepatt = /^(\d{3})-(\d{2})-(\d{4})$/;
    if (ssn.match(donepatt)) {
      let check: boolean = ValidationService.isSSNValidValue(ssn);
      if (!check) {
        if (!isOtherSsn) {
          this.MemberSsn.control.setErrors({
            ...(this.MemberSsn.control.errors || {}),
            invalidSsn: true,
          });
          return false;
        }
        if (isOtherSsn) {
          this.otherSsn.control.setErrors({
            ...(this.otherSsn.control.errors || {}),
            invalidSsn: true,
          });
          return false;
        }
      }

      if (isOtherSsn && this.memberObj1.ssnNum == ssn) {
        this.ssnValidationError = 'Duplicate ssn in the form';
        this.otherSsn.control.setErrors({
          ...(this.otherSsn.control.errors || {}),
          duplicate: true,
        });
        return false;
      }

      for (let othermember of this.formNv.referralMemberList) {
        if (isOtherSsn && othermember.ssnNum == ssn && (this.editIndex == undefined || this.getIndexByName(ssn) !==this.editIndex )) {
          this.ssnValidationError = 'Duplicate ssn in the form';
          this.otherSsn.control.setErrors({
            ...(this.otherSsn.control.errors || {}),
            duplicate: true,
          });
          return false;
        }
      }
    }

    return false;
  }
  getIndexByName(name: string): number {
    return this.formNv.referralMemberList.findIndex(item => item.ssnNum === name);
  }

  policyHolderCheck() {
    const resAddress = this.resAddressFormControl.getRawValue();
    const mailAddress = this.mailAddressFormControl.getRawValue();
    let requiredFields: boolean =  this.existingMember != '' &&
    ((this.existingMember == 'No' &&  this.formNv.referralCase.sourceCd != '') ||
      (this.existingMember == 'Yes' && this.updateReason != ''))

    && this.memberObj1.firstNm != ''
    && this.memberObj1.lastNm != ''
    && this.memberObj1.ssnNum != ''
    && this.memberVOdobDt != null
    && (this.isMemberMedicaid == 'No' || (this.isMemberMedicaid =='Yes'&& this.memberObj1.maNum !=''))
    && this.memberObj1.gender !=''
    && (resAddress.addressLine1Txt !='' && resAddress.stateCd !='' && resAddress.zipCd !='' && resAddress.cityTxt !='' && this.isSameMailingAddress !='')
    &&( this.isSameMailingAddress == 'No' &&  mailAddress.addressLine1Txt !='' && mailAddress.stateCd !='' && mailAddress.zipCd !='' && mailAddress.cityTxt !='' || ( this.isSameMailingAddress =='Yes' ));

    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = [
        'caseVO.sourceCd',
        'memberVO.firstNm',
        'memberVO.miNm',
        'memberVO.lastNm',
        'memberObj.ssnNum',
        'd1',
        'memberVO.gender',
        'memberVO.maNum',
        'caseVO.addressLine1Txt',
        'caseVO.addressLine2Txt',
        'caseVO.cityTxt',
        'caseVO.stacdRf',
        'caseVO.zip5Cd',
        'caseVO.phone1Num',
        'caseVO.phone2Num',
        'caseVO.emailTxt',
        'isSameMailingAddress',
        'mailAddress.addressLine1Txt',
        'mailAddress.addressLine2Txt',
        'mailAddress.cityTxt',
        'mailAddress.stacdRf',
        'mailing.zip5Cd',
        'mailingState.phone1Num',
        'existingMember',
        'updateReason',
        'othermaNum',
        'memberVO.maNum',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }

    return requiredFields && valid;
  }

  employerPolicyCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck()  && this.checkPage2Valid()
      && this.formNv.referralPolicy.policySourceCd != '' &&
      ((this.existingMember == 'Yes' &&
        this.formNv.referralPolicy.employeePremium != '' &&
        this.formNv.referralPolicy.planTier != '' &&
        this.formNv.referralPolicy.frequency != '' &&
        this.formNv.referralPolicy.premiumPaidOption != '' &&
        this.formNv.referralPolicy.individualMaxDeductible != '' &&
        this.formNv.referralPolicy.familyMaxDeductible != '') ||
        (this.existingMember == 'No' &&
          this.formNv.referralEmployer.emplyrNm != '' &&
          this.formNv.referralEmployer.addressLine1Txt != '' &&
          this.formNv.referralEmployer.cityTxt != '' &&
          this.formNv.referralEmployer.stateCd != '' &&
          this.formNv.referralEmployer.zipCd != '' &&
          this.formNv.referralEmployer.phoneNum != '' &&
          this.formNv.referralEmployer.emplyrFein != '' &&
          this.openenrollmentstartdate != null &&
          this.openenrollmentenddate != null));
    //&& this.formNv.policy.employeePremium != '';
    // && this.formNv.policy.individualMaxDeductible != ''
    // && this.formNv.policy.familyMaxDeductible != ''
    // && this.formNv.policy.planTier !=''
    // && this.formNv.policy.frequency !='';
    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = [
        'isHealthInsurance',
        'employerVO.emplyrNm',
        'employerVO.addressLine1Txt',
        'employerVO.addressLine2Txt',
        'employerVO.cityTxt',
        'employerVO.stacdRf',
        'employerVO.zip5Cd',
        'employerVO.phoneNum',
        'employerVO.phone1Num',
        'employerVO.emplyrFein',
        'policyVO.carrierNm',
        'policyVO.addressLine1Txt',
        'policyVO.addressLine2Txt',
        'policyVO.cityTxt',
        'policyVO.stacdRf',
        'policyVO.zip5Cd',
        'policyVO.phoneNum',
        'policyVO.planNm',
        'policyVO.policyNum',
        'policyVO.groupNum',
        'd3',
        'd8',
        'd9',
        'premium',
        'Single Deductible',
        'Family Deductible',
        'policyVO.frequency',
        'policyVO.planTier',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }

    return requiredFields && valid;
  }

  familyMemberCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.isFamilyMemberMedicate != '' &&
      ((this.checkAdditionalMembers() && this.isFamilyMemberMedicate != '') ||
        this.isFamilyMemberMedicate == 'No');

    let valid = true;
    const form = this.customerForm?.form;

    if (requiredFields && form != null) {
      let page1 = [
        'isFamilyMemberMedicate',
        'otherfirstNm',
        'othermiNm',
        'otherlastNm',
        'otherssnNum',
        'd6',
        'othermaNum',
        'othergenderRf',
        'd7',
        'otherrelationshipRf',
        'otherEnrolled',
        'isOtherMedicaid',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }
    let checkFmailyFilled: boolean = false;
    if (
      this.otherfirstNm != '' &&
      this.otherlastNm != '' &&
      (this.otherdobDate != null && this.otherDob!=null && this.otherDob.control.value !='') &&
      this.otherEnrolled != '' && this.isOtherMedicaid !='' &&
      ((this.isOtherMedicaid =='Yes' && this.othermaNum != '')|| this.isOtherMedicaid =='No')
    ) {
      checkFmailyFilled = true;
    } else {
      checkFmailyFilled = false;
    }
    if(this.isMemberMedicaid == 'No' && this.formNv.referralMemberList.length > 0){
      this.othermedicaidavailable =false;
     this.formNv.referralMemberList.forEach(mem => {
       if(mem.medicaidRecipient == true && mem.maNum != ''){
         this.othermedicaidavailable = true;
       }
     });

   }

    return (
      requiredFields &&
      valid &&
      !checkFmailyFilled &&
      !(this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No') &&
      !(this.isMemberMedicaid == 'No' && this.isFamilyMemberMedicate == 'Yes' && this.othermedicaidavailable == false)
    );
  }
  checkAdditionalMembers() {
    if (
      this.isFamilyMemberMedicate == 'Yes' &&
      this.formNv.referralMemberList.length == 0
    ) {
      return false;
    } else {
      return true;
    }
  }

  rightsResponsibilityCheck() {
    return (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.signReadCheck
    );
  }

  voterRegistrationCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.rightsResponsibilityCheck() &&
      this.formNv.referralCase.hipaaRecipientFirstNm != '' &&
      this.formNv.referralCase.hipaaRecipientLastNm != '' &&
      this.hippeffectivedate != null &&
      this.hippeffectivedate1 != null &&
      this.formNv.referralCase.hipaaSubmitterFirstName != '' &&
      this.formNv.referralCase.hipaaSubmitterLastName != '';

    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = [
        'hipaaRecipientFirstNm',
        'hipaaRecipientLastNm',
        'hippEffectiveDate',
        'hipaaSubmitterFirstName',
        'hipaaSubmitterLastName',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }

    return requiredFields && valid;
  }

  submitCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.rightsResponsibilityCheck() &&
      this.voterRegistrationCheck() &&
      this.signElectronicSignatureChecked &&
      this.signApplicant != '' &&
      this.formNv.referralCase.submitterFirstName != '' &&
      this.formNv.referralCase.submitterLastName != '' &&
      this.captchaEntered != '';

    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = [
        'signElectronicSignatureChecked',
        'signApplicant',
        'signfirstNm',
        'signLastName',
        'captcha',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }

    return requiredFields && valid;
  }
  seconds: number = 0;
  timer: any;
  timerStart(minute: number) {
    if (this.seconds > 0) {
      this.seconds = this.seconds + minute * 60;
    } else {
      this.seconds = minute * 60;
    }
    let textSec: any = '0';
    let statSec: number = 60;

    const prefix = Math.floor(this.seconds / 60) < 10 ? '0' : '';

    this.timer = setInterval(() => {
      this.seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      textSec = statSec.toString().padStart(2, '0');
      let minutes = Math.floor(this.seconds / 60)
        .toString()
        .padStart(2, '0');
      this.display = `${minutes}:${textSec}`;
      if (this.seconds == 60 && !this.isValidFormSubmitted) {
        this.openDialog();
      }
      if (this.seconds == 0) {
        console.log('finished');
        window.scrollTo(0, 0);
        if (!(window as any).__KARMA_TEST_MODE__) {
          window.location.reload();
        }
        clearInterval(this.timer);
      }
    }, 1000);
  }

  isMedicaidMember() {
    if (this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No') {
      this.openMedicaidDialog();
    }
    this.memberObj1.maNum = '';
    this.memberMedicateRequired = false;
  }
  openMedicaidDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Medicaid Member Required',
        content: `<br />
      <p>Nevada HIPP applicants must be active Medicaid clients.<br />Based on your responses, you do not qualify for HIPP.</p>
      <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //clearInterval(this.timer);
        //this.timerStart(15);
      } else if (result == false) {
        // this.changeResetMessageCalled.emit('resetForm');
        //window.scrollTo(0, 0);
      }
    });
  }
  sameMailingAddress() {
    this.mailAddressFormControl.patchValue({
      addressLine1Txt :'',
      addressLine2Txt :'',
      stateCd :'',
      zipCd :'',
      cityTxt :''
    })
    this.showMailAddress = false;
    this.mailAddress1Required = false;
    this.mailCityRequired = false;
    this.mailStateRequired = false;
    this.mailZipRequired = false;
  }

  openDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Session Timer',
        content: `<br />
        <p>Your session is about to end, and your changes will not be saved. </p>
        <p> Would you like to extend your session?</p>
        <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        clearInterval(this.timer);
        this.timerStart(15);
      } else if (result == false) {
        this.changeResetMessage();
        window.scrollTo(0, 0);
      }
    });
  }


  checkFirstChar(event: any, control: FormControl) {
    if(event.target.value.length >= 1) {
      return true;
    }

    const isValid = ValidationService.allowAlphaNumeric(
      event,
      this.deviceDetectorService.browser
    );

    if(!isValid || event.code == 'Space') {
      control.setErrors({...(control.errors || {}),'nomatch': true,'required':false});
    }
    return event.code != 'Space' && isValid;
  }

  allowAlphaNumericWithSplChar(event: any) {
    return ValidationService.allowAlphaNumericWithSplChar(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowOnlyOneAlphabet(event: any, control: NgModel) {
    return ValidationService.allowOnlyOneAlphabet(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  openPdf() {
    let bytes = this.submittedResponse.pdfBytes;

    let response = this.base64ToArrayBuffer(bytes);
    let file = new Blob([response], { type: 'application/pdf' });
    let fileURL: any = URL.createObjectURL(file);
    //window.open(fileURL);
    let anchor = document.createElement('a');
    anchor.href = fileURL;
    anchor.title = 'Submitted Form';
    anchor.ariaLabel = 'Submitted Form';
    anchor.lang = 'en';
    anchor.type = 'application/pdf';
    anchor.download = this.submittedResponse.referralId + '.pdf';
    anchor.click();
  }
  base64ToArrayBuffer(base64: any): ArrayBuffer {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  removeSavedFamilyMembers(event: any) {
    if (this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No') {
      this.openMedicaidDialog();
    }
    this.formNv.referralMemberList = [];
    this.additionalMaxReached = false;
    this.additionalMembersReq = false;

    this.clear(event);
  }

  verifyMemberFn() {
    let requiredFields: boolean =
      this.memberObj1.firstNm != '' &&
      this.memberObj1.lastNm != '' &&
      this.memberObj1.ssnNum != '' &&
      this.memberVOdobDt != null;

    if (!requiredFields) {
      this.firstNameRequired = true;
      this.lastNameRequired = true;
      this.ssnMemberRequired = true;
      this.memberDobRequired = true;
    }

    let valid = true;
    const form = this.customerForm?.form;

    if (requiredFields && form != null) {
      let page1 = [
        'memberVO.firstNm',
        'memberVO.lastNm',
        'memberObj.ssnNum',
        'd1',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }

    if (requiredFields && valid) {
      this.existingMemberFn();
      this.verifyMember.firstNm = this.memberObj1.firstNm;
      this.verifyMember.lastNm = this.memberObj1.lastNm;
      this.verifyMember.dobDt = this.getServerDate(this.memberVOdobDt);
      this.verifyMember.ssnNum = this.memberObj1.ssnNum;
      this.verifyMember.pierId = this.memberPierId;

      this.verifyMember.ssnNum = this.verifyMember.ssnNum.replaceAll('-', '');
      this.dataService.getVerifyExistingMember(this.verifyMember).subscribe({
        next: (response: verifyMemberResponse) => {
          if (response) {
            this.memberPierId = response.pierId;
            this.addMember = response.addMember;
            this.existingMember = response.existingMember ? 'Yes' : 'No';
            // this.formNv.referralCase.pierId = response.pierId;

          }
        },
        error: (err: HttpErrorResponse) => {

          this.logger.logMsg(err.error);
          const msg =
            'We are unable to verify Member details currently, please contact customer support at (877) 697-6703';
          this.errorMessage = msg;
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        },
      });
    }
    this.timerReset =Math.random()* 100;
  }

  openValidateMemberDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Family Member',
        content:
          `<br />
      <h1 class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> Invalid Member</h1>
      <p>This member <span class="text-danger">` +
          this.existingInvalidMemberName +
          `</span> details belongs to different case.</p>
      <p>Please re-check filled member details.</p>
      <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //clearInterval(this.timer);
        //this.timerStart(15);
      } else if (result == false) {
        // this.changeResetMessageCalled.emit('resetForm');
        //window.scrollTo(0, 0);
      }
    });
  }
  isMedicaidOther(){
    this.othermaNum ='';
    this.otherMaNumRequired =false;
  }
  phoneCheck(event : any, control: NgModel ){
    if(event.target.value =='' && control.control.errors && (control.control.hasError('nomatch') || control.control.hasError('pattern'))){
      if(!control.control.hasError('required')){
        control.control.setErrors(null);
      }else{
        control.control.setErrors({...(control.errors || {}),'nomatch': false, 'required':true});
      }
    }
  }
  validateAddress(address1Txt: any, city: any, state: any, zipCd: any){
    if(address1Txt.value != ''){
      if( city.value =="" || state.value =="" || zipCd.value ==""){
        if(!(address1Txt.errors && address1Txt.hasError('po')))
        address1Txt.setErrors({...(address1Txt.errors || {}),'invalid': true,});
      }else{
        if(address1Txt.errors && address1Txt.hasError('invalid'))
          delete  address1Txt.errors['invalid'];
      }
    }else if(address1Txt.errors && !address1Txt.hasError('required')){
      address1Txt.setErrors(null);
    }
  }
  parseDate(date: any, control: NgModel){
    this.phoneCheck(date, control);
    let donepatt = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    if((date.target.value.length > 0 &&  date.target.value.length < 8) ){
      control.control.setErrors({...(control.errors || {}),'invalidDate': true,'required':false});
    }else{
      if(control.control.errors && control.control.hasError('invalidDate'))
      delete  control.control.errors['invalidDate'];
    }
    if(donepatt.test(date.target.value)){
      let parseDate =  moment(date.target.value, 'MM/DD/YYYY');
      if(!parseDate.isValid()){
        control.control.setErrors({...(control.errors || {}),'invalidDate': true,'required':false});
      }else{
        if(control.control.errors && control.control.hasError('invalidDate'))
          delete  control.control.errors['invalidDate'];
      }
    } 
    
  }
  compareDate(control: NgModel, control2: NgModel) {
    if (
      this.openenrollmentstartdate != null &&
      this.openenrollmentenddate != null &&
      this.openenrollmentenddate <= this.openenrollmentstartdate
    ) {
      control.control.setErrors({
        ...(control.errors || {}),
        invalidEndDate: true,
      });
    } else {
      if (control.control.errors)
        delete control.control.errors['invalidEndDate'];
      if (control2.control.errors && control2.control.errors['invalidEndDate'])
         control2.control.setErrors(null);
    }
  }

  private setPreviousVal(tempSelectedStreetLine: any, propName: string) {
    if(config.validateAddresses){
    switch (propName) {
      case 'resAddress': this.previousValRes = tempSelectedStreetLine; break;
      case 'mailAddress': this.previousValMail = tempSelectedStreetLine; break;
      case 'referralEmployerAddress': this.previousValRefEmp = tempSelectedStreetLine; break;
      case 'referralPolicyAddress': this.previousValRefPol = tempSelectedStreetLine; break;
      default: "";
    }
  }
  }
  validateCarrierNm(event : any, control: NgModel ){
    let regex=/^(?![ \-/()])([a-zA-Z0-9]+(?: {0,1}(?:[\-/] {0,1})?[a-zA-Z0-9]+)*)(?: {0,1}\((?![ -])[A-Za-z]+(?:\s{0,1}[A-Za-z]+|\s{0,1}[-]\s{0,1}(?![ -])[A-Za-z]+)*\) *(?:[a-zA-Z0-9]+(?: {0,1}(?:[\-/] *)?[a-zA-Z0-9]+)*)*)?(?![ \-/()])$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validatePlanNm(event : any, control: NgModel ){
    let regex=/^(?![ .,\/#&-])[A-Za-z0-9]+(?:\s{0,1}[A-Za-z0-9]+|\s{0,1}[.,\/#&-]\s{0,1}(?![ .,\/#&-])[A-Za-z0-9]+)*$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validateGroupNum(event : any, control: NgModel ){
    let regex=/^(?![ -])[A-Za-z0-9]+(?:\s{0,1}[A-Za-z0-9]+|\s{0,1}[-]\s{0,1}(?![ -])[A-Za-z0-9]+)*$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validatePolicyId(event : any, control: NgModel ){
    let regex=/^[a-zA-Z0-9]+$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
}
